import { Action } from 'redux';
import ILoanDrawdownCondition from '~Api/LoanDrawdowns/ILoanDrawdownCondition';
import ILoanDrawdownConditionDocument from '~Api/LoanDrawdowns/ILoanDrawdownConditionDocument';
import LoanDrawdownsActionsEnum from './ActionsEnum';
import IConditionSuggestion from '~Api/LoanDrawdowns/IConditionSuggestion';

export interface ILoanDrawdownConditionsWithDocumentsListAction extends Action {
    drawdownUuid: string;
}

export function loanDrawdownConditionsWithDocumentsListAction(drawdownUuid: string): ILoanDrawdownConditionsWithDocumentsListAction {
    return {
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionsWithDocumentsList,
    };
}

export interface ILoanDrawdownConditionsListAction extends Action {
    drawdownUuid: string;
}

export function loanDrawdownConditionsListAction(drawdownUuid: string): ILoanDrawdownConditionsListAction {
    return {
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionsList,
    };
}

export interface ILoanDrawdownConditionsSetAction extends Action {
    drawdownConditions: ILoanDrawdownCondition[];
    drawdownUuid: string;
}

export function loanDrawdownConditionsSetAction(drawdownUuid: string, drawdownConditions: ILoanDrawdownCondition[]): ILoanDrawdownConditionsSetAction {
    return {
        drawdownConditions,
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionsSet,
    };
}

export interface ILoanDrawdownConditionsAddAction extends Action {
    drawdownUuid: string;
    loanDrawdownCondition: ILoanDrawdownCondition;
}

export function loanDrawdownConditionsAddAction(drawdownUuid: string, loanDrawdownCondition: ILoanDrawdownCondition): ILoanDrawdownConditionsAddAction {
    return {
        drawdownUuid,
        loanDrawdownCondition,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionsAdd,
    };
}

export interface ILoanDrawdownConditionSetAction extends Action {
    drawdownCondition: ILoanDrawdownCondition;
}

export function loanDrawdownConditionSetAction(drawdownCondition: ILoanDrawdownCondition): ILoanDrawdownConditionSetAction {
    return {
        drawdownCondition,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionSet,
    };
}

export interface ILoanDrawdownConditionDeleteAction extends Action {
    loanDrawdownConditionUuid: string;
}

export function loanDrawdownConditionDeleteAction(loanDrawdownConditionUuid: string): ILoanDrawdownConditionDeleteAction {
    return {
        loanDrawdownConditionUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDelete,
    };
}

export interface ILoanDrawdownConditionDocumentsListAction extends Action {
    drawdownUuid: string;
}

export function loanDrawdownConditionDocumentsListAction(drawdownUuid: string): ILoanDrawdownConditionDocumentsListAction {
    return {
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDocumentsList,
    };
}

export interface ILoanDrawdownConditionDocumentsAddAction extends Action {
    file: File;
    loanDrawdownConditionUuid: string;
}

export function loanDrawdownConditionDocumentsAddAction(
    file: File,
    loanDrawdownConditionUuid: string,
): ILoanDrawdownConditionDocumentsAddAction {
    return {
        file,
        loanDrawdownConditionUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDocumentsAdd,
    };
}

export interface ILoanDrawdownConditionDocumentsSetAction extends Action {
    drawdownConditionDocuments: ILoanDrawdownConditionDocument[];
    drawdownUuid: string;
}

export function loanDrawdownConditionDocumentsSetAction(drawdownUuid: string, drawdownConditionDocuments: ILoanDrawdownConditionDocument[]): ILoanDrawdownConditionDocumentsSetAction {
    return {
        drawdownConditionDocuments,
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDocumentsSet,
    };
}

export interface ILoanDrawdownConditionDocumentSetAction extends Action {
    drawdownConditionDocument: ILoanDrawdownConditionDocument;
}

export function loanDrawdownConditionDocumentSetAction(drawdownConditionDocument: ILoanDrawdownConditionDocument): ILoanDrawdownConditionDocumentSetAction {
    return {
        drawdownConditionDocument,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDocumentSet,
    };
}

export interface ILoanDrawdownConditionDocumentDeleteAction extends Action {
    loanDrawdownConditionDocumentUuid: string;
}

export function loanDrawdownConditionDocumentDeleteAction(loanDrawdownConditionDocumentUuid: string): ILoanDrawdownConditionDocumentDeleteAction {
    return {
        loanDrawdownConditionDocumentUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionDocumentDelete,
    };
}

export interface ILoanDrawdownConditionSuggestionsListAction extends Action {
    drawdownUuid: string;
}

export function loanDrawdownConditionSuggestionsListAction(drawdownUuid: string): ILoanDrawdownConditionSuggestionsListAction {
    return {
        drawdownUuid,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionSuggestionsList,
    };
}

export interface ILoanDrawdownConditionSuggestionsSetAction extends Action {
    drawdownUuid: string;
    suggestions: IConditionSuggestion[];
}

export function loanDrawdownConditionSuggestionsSetAction(drawdownUuid: string, suggestions: IConditionSuggestion[]): ILoanDrawdownConditionSuggestionsSetAction {
    return {
        drawdownUuid,
        suggestions,
        type: LoanDrawdownsActionsEnum.LoanDrawdownConditionSuggestionsSet,
    };
}